import { Observable } from 'rxjs';
import { PlanEntity } from '../entities/plan.entity';

export abstract class PlanPort {
  abstract getPlan(): Observable<PlanEntity>;
}
